import {Dispatch} from "redux";

import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {recommendationsDistanceInKm} from "../../constants/multi_lead/application_multi_lead_constants";
import {IApplicationData} from "../../types/IApplicationData";
import {fetchApplicationMultiLeadRecommendations} from "./fetch_application_multi_lead_recommendations";
import {getStorageSentApplicationsIdListByOffer} from "./get_storage_sent_applications_id_list_by_offer";

interface IGetSimpleMultiLeadRecommendationsParams {
    dispatch: Dispatch;
    sentApplication: IApplicationData | null;
    offer?: IOfferDetailApplication;
    property?: IPropertyDetailApplication;
    recommendedFilters?: Record<string, string>;
}

export async function fetchApplicationMultiLeadSimpleRecommendations(params: IGetSimpleMultiLeadRecommendationsParams) {
    const {sentApplication, offer, property, recommendedFilters, dispatch} = params;

    const excludedOfferIds = getStorageSentApplicationsIdListByOffer(offer, {limit: 50, distance: recommendationsDistanceInKm * 1000});

    // In case of NOT ADDING the radius to fetch payload, update FormSuccessInfoContainer tracking hit
    return fetchApplicationMultiLeadRecommendations({
        dispatch,
        offerId: offer?.id,
        propertyId: property?.id,
        numberOfRooms: sentApplication?.rooms,
        excludedOfferIds,
        filters: {
            ...recommendedFilters,
            radius: recommendationsDistanceInKm.toString()
        }
    });
}
import {Dispatch} from "redux";

import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {recommendationsDistanceInKm} from "../../constants/multi_lead/application_multi_lead_constants";
import {IApplicationData} from "../../types/IApplicationData";
import {fetchApplicationMultiLeadRecommendations} from "./fetch_application_multi_lead_recommendations";
import {getStorageSentApplicationsIdListByOffer} from "./get_storage_sent_applications_id_list_by_offer";

interface IGetSimpleMultiLeadRecommendationsParams {
    dispatch: Dispatch;
    sentApplication: IApplicationData | null;
    offer?: IOfferDetailApplication;
    property?: IPropertyDetailApplication;
    recommendedFilters?: Record<string, string>;
}

export async function fetchApplicationMultiLeadSimpleRecommendations(params: IGetSimpleMultiLeadRecommendationsParams) {
    const {sentApplication, offer, property, recommendedFilters, dispatch} = params;

    const excludedOfferIds = getStorageSentApplicationsIdListByOffer(offer, {limit: 50, distance: recommendationsDistanceInKm * 1000});

    // In case of NOT ADDING the radius to fetch payload, update FormSuccessInfoContainer tracking hit
    return fetchApplicationMultiLeadRecommendations({
        dispatch,
        offerId: offer?.id,
        propertyId: property?.id,
        numberOfRooms: sentApplication?.rooms,
        excludedOfferIds,
        filters: {
            ...recommendedFilters,
            radius: recommendationsDistanceInKm.toString()
        }
    });
}
